import { PathKeys, pathNames } from './paths';

export const links: { [key in PathKeys]: string } = {
  payroll: `/${pathNames.payroll}`,
  payrollHelp: `/${pathNames.payroll}/${pathNames.payrollHelp}`,
  reportPayroll: `/${pathNames.payroll}/${pathNames.reportPayroll}`,
  employments: `/${pathNames.employments}`,
  employmentsHelp: `/${pathNames.employments}/${pathNames.employmentsHelp}`,
  editEmployment: `/${pathNames.employments}/${pathNames.editEmployment}`,
  editEmployee: `/${pathNames.employments}/${pathNames.editEmployee}`,
  addEmployee: `/${pathNames.employments}/${pathNames.addEmployee}`,
  editEmploymentPeriod: `/${pathNames.employments}/${pathNames.editEmploymentPeriod}`,
  addEmploymentPeriod: `/${pathNames.employments}/${pathNames.addEmploymentPeriod}`,
  editParameter: `/${pathNames.employments}/${pathNames.editParameter}`,
  addEmployment: `/${pathNames.employments}/${pathNames.addEmployment}`,
  invoices: `/${pathNames.invoices}`,
  invoicesHelp: `/${pathNames.invoices}/${pathNames.invoicesHelp}`,
  markups: `/${pathNames.markups}`,
  fileDashboard: `/${pathNames.fileDashboard}`,
  fileDashboardHelp: `/${pathNames.fileDashboard}/${pathNames.fileDashboardHelp}`,
  payHistory: `/${pathNames.fileDashboard}/${pathNames.payHistory}`,
  reportHistory: `/${pathNames.fileDashboard}/${pathNames.reportHistory}`,
};

export const elementLinks = {
  fileUpload: 'File_upload',
};

export const skipLink = 'innehall';
